import React from 'react';
import {
  TextField,
  FormControlLabel,
  MenuItem,
  alpha,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';

// Custom styled components extracted from JoinForm
export const StyledTextField = (props: any) => (
  <TextField
    {...props}
    InputLabelProps={{
      style: { fontFamily: '"Poppins", sans-serif', fontWeight: 500 },
      shrink: undefined,
      ...props.InputLabelProps
    }}
    InputProps={{
      style: { fontFamily: '"Poppins", sans-serif' },
      ...props.InputProps
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        height: props.multiline ? 'auto' : '42px',
        '&:hover fieldset': {
          borderColor: (theme) => alpha(theme.palette.primary.main, 0.6),
        },
        '&.Mui-focused fieldset': {
          borderWidth: '2px',
        }
      },
      '& .MuiInputBase-input': {
        padding: props.multiline ? '8px 12px' : '6px 12px',
      },
      '& .MuiInputLabel-root': {
        fontSize: '0.85rem',
        transform: 'translate(12px, 12px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(12px, -9px) scale(0.85)',
        }
      },
      '& .MuiOutlinedInput-notchedOutline': {
        paddingLeft: '8px',
      },
      ...props.sx
    }}
    margin="dense"
    size="small"
    variant="outlined"
  />
);

// Enhanced dropdown style
export const StyledSelect = (props: any) => {
  const { label, options, ...otherProps } = props;
  
  return (
    <FormControl 
      fullWidth 
      size="small" 
      sx={{ 
        margin: '4px 0',
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          height: '42px',
          fontFamily: '"Poppins", sans-serif',
          '&:hover fieldset': {
            borderColor: (theme) => alpha(theme.palette.primary.main, 0.6),
          },
          '&.Mui-focused fieldset': {
            borderWidth: '2px',
          },
          // Make the dropdown icon more visible
          '& .MuiSvgIcon-root': {
            color: '#000000', // Black for visibility
            fontSize: '24px',
            right: '7px',
          },
          // Ensure the entire field is clickable
          cursor: 'pointer',
          '& .MuiSelect-select': {
            cursor: 'pointer',
          }
        },
        '& .MuiSelect-select': {
          padding: '6px 12px',
          paddingRight: '32px !important',
        },
        '& .MuiInputLabel-root': {
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 500,
          fontSize: '0.85rem',
          transform: 'translate(12px, 12px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(12px, -9px) scale(0.85)',
          }
        },
        ...otherProps.sx
      }}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        {...otherProps}
        label={label}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              fontFamily: '"Poppins", sans-serif',
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          }
        }}
      >
        {options.map((option: any) => {
          // Handle different formats for country vs other options
          if (typeof option === 'object' && option.code && option.name) {
            return (
              <MenuItem 
                key={option.code} 
                value={option.name} 
                sx={{ fontFamily: '"Poppins", sans-serif' }}
              >
                {option.name}
              </MenuItem>
            );
          }
          return (
            <MenuItem 
              key={option} 
              value={option} 
              sx={{ fontFamily: '"Poppins", sans-serif' }}
            >
              {option}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export const StyledFormControlLabel = (props: any) => (
  <FormControlLabel
    {...props}
    sx={{ 
      '& .MuiFormControlLabel-label': {
        fontFamily: '"Poppins", sans-serif',
        fontSize: '0.85rem',
      },
      '& .MuiCheckbox-root': {
        padding: '4px',
      },
      margin: 0,
      ...props.sx
    }}
  />
); 